import React, { Fragment } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Heading, { SubHeading } from '../heading';

export const Wrapper = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  color: #ffffff;
  height: calc(100% - 4rem);
  padding: 1em 2em;
  justify-content: space-around;
  @media (max-width: 767px) {
    padding: 0;
    flex-direction: column;
    justify-content: initial;
  }
`;

export const Section = styled.section`
  flex: 1;
  max-width: 40em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: column;
`;

const TitleBlock = styled.div`
  @media (min-width: 768px) {
    font-size: 2em;
    align-self: center;
    margin: 0 1em 0 0;
    max-width: min(50vw, 30em);
    text-align: center;
    > * {
      max-width: 40vw;
    }
  }
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

const Scroller = styled.div`
  overflow-y: auto;
  @media (max-width: 767px) {
    height: 100%;
  }
`;

const Content = ({ children }) => {
  return (
    <Fragment>
      <ContentWrapper>
        <Scroller>{children}</Scroller>
      </ContentWrapper>
    </Fragment>
  );
};

const ContentWithActions = ({ children, actions }) => {
  return (
    <Section>
      <ContentWrapper>
        <Scroller>{children}</Scroller>
      </ContentWrapper>
      <div>{actions}</div>
    </Section>
  );
};

const TitledSection = ({ title, titleId, subtitleId, actions, children }) => {
  const ContentComponent = actions ? ContentWithActions : Content;
  return (
    <Wrapper>
      <TitleBlock>
        <Heading>
          {title}
          {titleId && <Translate id={titleId} />}
        </Heading>
        {subtitleId && (
          <SubHeading>
            <Translate id={subtitleId} />
          </SubHeading>
        )}
      </TitleBlock>
      <ContentComponent actions={actions}>{children}</ContentComponent>
    </Wrapper>
  );
};

export default TitledSection;
